<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaTarifas"
      :titulo="$t ('Tarifas')"
      icono="mdi-progress-clock"
      tabla="tar"
      :campos="['id_tar-', 'des+', 'tip', 'impfij', 'id_lispre_def', 'tiecor', 'tiereg', 'limimp24h']"
      busqueda-rapida
      :titulo-crud="$t ('tarifa')"
      :evento-despues-guardar-formulario-datos="despuesGuardarFormularioDatosTarifas"
      :formulario-datos-api-props="{ anchoMaximo: '950', sinMargenes: true }"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      @montado="montadoTablaDatos"
    >
      <!-- F O R M U L A R I O -->

      <template v-slot:default="{ definicionCampos, datosRegistro, esAccionEliminar }">
            <v-container class="mt-5 px-6">
              <v-row>
                <v-col class="pb-0">
                  <CampoFormularioDatos nombre-campo="des" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="tip" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="impfij" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="id_lispre_def" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="tiecor" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="tiereg" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <CampoFormularioDatos nombre-campo="limimp24h" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  <!-- <CampoFormularioDatos nombre-campo="vis" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" /> -->
                </v-col>

                <v-col v-show="datosRegistro.tip==0" cols="12" md="8" class="pb-0">

                  <!-- L I S T A   D E   F R A N J A S -->

                  <div class="mt-n3 mb-2">{{ $t ('Lista de franjas') }}</div>
                  <TablaDatosAPI
                    icono="mdi-calendar-week-begin"
                    tabla="fratar"
                    :campos="['dia', 'ini', 'fin', 'id_lispre']"
                    :parametros="parametros_tabla_relacionada"
                    modo-memoria
                    titulo-crud="franja de tarifa"
                    :permitir-anadir="!esAccionEliminar"
                    :permitir-modificar="!esAccionEliminar"
                    :permitir-eliminar="!esAccionEliminar"
                    dense
                    @cambios="cambiosEnTablaRelacionada (datosRegistro)"
                    @montado="montadoTablaDatos"
                    >
                  </TablaDatosAPI>
                  <div style="height: 15px"></div>
                </v-col>
              </v-row>
            </v-container>
      </template>
    </TablaDatosAPI>
  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from "@/components/CampoFormularioDatos.vue";
import api from '@/api'

export default {
  components: { TablaDatosAPI, CampoFormularioDatos },
  data() {
    return {
      tablasDatos: [],
    }
  },
  methods: {
    montadoTablaDatos (tablaDatos) {
      this.tablasDatos [tablaDatos.tabla] = tablaDatos;
    },
    cambiosEnTablaRelacionada (datosRegistroTarifa) {
      if (this.tablasDatos ['fratar'].hayCambiosModoMemoria())
        this.$set (datosRegistroTarifa, 'ctr__AUX', true); // ctr = Cambios en Tabla relacionada
      else
        this.$delete (datosRegistroTarifa, 'ctr__AUX');
    },
    despuesGuardarFormularioDatosTarifas (formularioDatosAPI) {
      api.loteCambiosRegistrosTablaVista ('fratar', this.tablasDatos ['fratar'].loteCambiosRegistros((registro) => { registro.id_tar = formularioDatosAPI.datosRegistro ['id_tar'] }));
    },
  },
  computed: {
    parametros_tabla_relacionada() {
      return {
        idTarifa: { valor: this.tablasDatos['tar'].formulario.datosRegistro ['id_tar'] ?? 0, descripcion: '' }
      };
    },
  }
};
</script>

<style>
</style>